<script>
  import { filetree } from "../Automator/store";
  import { createEventDispatcher } from "svelte";
  import { Icon, DocumentText, XMark } from "svelte-hero-icons";

  export let value = null;
  export let isReadonly = false;
  export let label = "";
  export let optional = false;
  export let includeMainFiles = false;

  $: items = filetree.itemsAsFlatList;
  $: reference_id = value instanceof Object ? value.id : value;

  const dispatch = createEventDispatcher();

  function handleSelect(workflow) {
    if (isReadonly) return;
    if (value instanceof Object) {
      dispatch("input", { id: workflow.id, name: workflow.name, last_referenced_name: value.name });
    } else {
      dispatch("input", { id: workflow.id, name: workflow.name, last_referenced_name: null });
    }
  }

  function clearSelection() {
    if (isReadonly) return;
    dispatch("input", null);
  }
</script>

<!-- Replace the label with proper form control -->
{#if label}
  <label for="workflow-group" class="block text-content-subtle text-xs mb-2">{label}</label>
{/if}

<div class="border border-line-strong rounded-lg p-2 max-w-md" class:opacity-50={isReadonly}>
  <div class="flex justify-between items-center mb-1">
    <h3 class="font-semibold text-xs">Workflows</h3>
    <div class="flex items-center">
      {#if optional && value}
        <button
          class="text-xs text-content-subtle hover:text-content focus:outline-none"
          on:click={clearSelection}
          disabled={isReadonly}
        >
          <Icon src={XMark} class="w-4 h-4" />
        </button>
      {/if}
      <slot name="dynamic" />
    </div>
  </div>
  <ul class="space-y-0.5 max-h-48 overflow-y-auto" id="workflow-group" role="radiogroup">
    {#each $items as workflow (workflow.id)}
      {#if includeMainFiles || (workflow.meta?.type === "library" && !workflow.is_folder)}
        <li>
          <label
            class="w-full text-left flex items-center px-1.5 py-0.5 rounded-sm hover:bg-surface-hover focus:outline-none focus:bg-surface-muted text-xs cursor-pointer"
          >
            <input
              type="radio"
              name="workflow-selection"
              checked={reference_id === workflow.id}
              class="mr-1.5 h-3 w-3"
              on:change={() => handleSelect(workflow)}
              disabled={isReadonly}
            />
            <Icon src={DocumentText} class="w-3 h-3 text-content-muted mr-1 shrink-0" />
            <span class="truncate">{workflow.name}</span>
          </label>
        </li>
      {/if}
    {/each}
  </ul>
</div>
